export const RequestSignatureResources = {
	es: {
		['title']: 'Firma',
		['click_here_to_sign']: 'Toca aquí para firmar',
        ['click_here_to_sign_optional']: 'Clic aqui para firmar (Opcional)',
		['agreement']: 'Contrato',
		['sign_your_agreement']: 'Firma tu contrato',
		['terms_and_conditions']: 'Términos y condiciones',
        ['read_your_agreement']: 'Lee tu contrato, en él se establece todos los terminos y condiciones.',
        ['sign_your_agreement_desc']: 'Fírma con tu firma autógrafa para continuar con tu proceso de renta. Asegurate que sea lo mas fiel a tu documento de identidad',
        ['sign_then']: 'Continua con firma',
        ['enter_signature']: 'Ingresa tu firma',
        ['confirm_terms_conditions']: 'Confirmo que estoy de acuerdo con los términos y condiciones establecidos. Confirmo que los leí en su totalidad.',
        ['accept_terms_conditions']: 'Acepto términos y condiciones',
	},
	en: {
        ['title']: 'Signature',
        ['click_here_to_sign']: 'Tap here to sign',
        ['click_here_to_sign_optional']: 'Click here to sign (Optional)',
		['agreement']: 'Agreement',
		['sign_your_agreement']: 'Sign your agreement',
		['terms_and_conditions']: 'Terms and conditions',
        ['read_your_agreement']: 'Read your contract; it stipulates all the terms and conditions.',
        ['sign_your_agreement_desc']: 'Please provide your handwritten signature to proceed with your rental process. Ensure that it matches your government-issued ID as closely as possible.',
        ['sign_then']: 'Sign',
        ['enter_signature']: 'Enter your signature',
        ['confirm_terms_conditions']: 'I confirm that I agree to the established terms and conditions. I confirm that I have read them in their entirety.',
        ['accept_terms_conditions']: 'I accept the terms and conditions',
	}
}
